import type { CSSProperties } from "react";

import { spiralOrder } from "../lib/dotPaths";

const ORDER = spiralOrder(5);

// Сдвиги столбцов эквалайзера неровные: ровные дали бы бегущую волну, а не
// «живой уровень».
const BAR_PHASE = [0, 0.35, 0.7, 0.15, 0.55];

interface Props {
  /** Спираль — ожидание результата; столбцы — идущая передача данных. */
  variant?: "spiral" | "bars";
  size?: "sm" | "lg";
  /** Подпись для экранного диктора. Без неё лоадер декоративный. */
  label?: string;
}

/**
 * Точечный лоадер 5×5 — только там, где человек реально ждёт.
 *
 * Рисунки движения — по мотивам dotmatrix.zzzzshawn.cloud («Core Spiral»,
 * «Sound Bars»). Код их библиотеки не переносили: лицензия проприетарная, а
 * ядро весит 46 КБ и тащит градиентные пресеты с цветами мимо токенов. Здесь
 * всё движение — CSS-анимации, без таймеров в JS; цвет — currentColor, так
 * что в синей кнопке точки белые, а в подписи — приглушённые.
 */
export default function DotLoader({ variant = "spiral", size = "sm", label }: Props) {
  return (
    <span
      className={`dots dots--${variant} dots--${size}`}
      role={label ? "status" : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    >
      {Array.from({ length: 25 }, (_, i) => {
        const row = Math.floor(i / 5);
        const col = i % 5;
        const height = 4 - row; // высота точки над нижним рядом
        const style =
          variant === "spiral"
            ? ({ "--n": ORDER[i] / 24 } as CSSProperties)
            : ({ "--phase": BAR_PHASE[col] } as CSSProperties);
        const className =
          variant === "bars" && height > 0 ? `dots__dot dots__dot--h${height}` : "dots__dot";
        return <span key={i} className={className} style={style} />;
      })}
    </span>
  );
}

/** Подпись занятой кнопки: точки и глагол вместо «Создаю…» с многоточием. */
export function BusyLabel({ text }: { text: string }) {
  return (
    <span className="busy">
      <DotLoader />
      {text}
    </span>
  );
}
